import styled from "styled-components"

const getDegFromDirection = (direction) => {
  switch (direction) {
    case "up":
      return "270deg"
    case "down":
      return "90deg"
    case "left":
      return "180deg"
    default:
      return "0deg"
  }
}

const getSize = (size) => {
  switch (size) {
    case "small":
      return "1rem"
    case "medium":
      return "1.5rem"
    case "large":
      return "1.75rem"
    default:
      return "1.25rem"
  }
}

const getColor = (color) => {
  switch (color) {
    case "primary":
      return (props) => props.theme.colors.primary
    case "secondary":
      return (props) => props.theme.colors.secondary
    case "current":
      return "currentColor"
    default:
      return (props) => props.theme.colors.body
  }
}

export const Icon = styled.svg`
  cursor: pointer;
  transform: rotate(${({ direction }) => getDegFromDirection(direction)});
  width: ${({ size }) => getSize(size)};
  height: ${({ size }) => getSize(size)};
  fill: ${({ color }) => getColor(color)};
  transition: transform 0.3s ease-in-out;
`
